var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('button',{staticClass:"k-primary k-button k-grid-edit-command",on:{"click":_vm.clickHandler}},[_vm._v("Acknowledge")])])}
var staticRenderFns = []

export { render, staticRenderFns }